<template>
    <div>
        <div>
            <div class="table-wrapper on-991" v-if="$i18n.locale=='en'"> 
                <div>
                    <table>
                        <thead >
                            <tr class="dark-gray">
                                <td colspan="3"><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="skyBlue bolder end font ligest-gray" >2020</td>
                                <td class="white bolder end font" >2019</td>
                            </tr>
                                <tr class="light-gray">
                                <td colspan="3"><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td colspan="2" class="center white bolder" >KD ’000</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="font" colspan="3" >Pella</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" >79,517</td>
                                <td class="end font" >79,517</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >Zain Sudan</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" >20,909</td>
                                <td class="end font" >25,488</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >Atheer</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" >487,889</td>
                                <td class="end font" >485,314</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >SMTC</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" > 14,965</td>
                                <td class="end font" >14,954</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >Others</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" > 2,182</td>
                                <td class="end font" >2,538</td>
                            </tr>
                            <tr class="dark-gray">
                                <td class="font" colspan="3" ><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font white font-weight-bold" > 605,462</td>
                                <td class="end font white font-weight-bold" >607,811</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <p v-if="$i18n.locale=='en'">Goodwill of KD 6.752 million related to Mada Jordan, was impaired during the previous year as a result of technology obsolescence.</p>
        </div>
            
            <!-- Arabic -->

            <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'"> 
                <div>
                    <table>
                        <thead >
                            <tr class="dark-gray">
                                <td colspan="3"><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="skyBlue bolder end font ligest-gray" >2020</td>
                                <td class="white bolder end font" >2019</td>
                            </tr>
                                <tr class="light-gray">
                                <td colspan="3"><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td colspan="2" class="center white bolder" >ألف دينار كويتي</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="font" colspan="3" >بيلا </td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" >79,517</td>
                                <td class="end font" >79,517</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >زين السودان</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" >20,909</td>
                                <td class="end font" >25,488</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >أثير</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" >487,889</td>
                                <td class="end font" >485,314</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >زين السعودية</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" > 14,965</td>
                                <td class="end font" >14,954</td>
                            </tr>
                            <tr>
                                <td class="font" colspan="3" >أخرى</td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font ligest-gray" > 2,182</td>
                                <td class="end font" >2,538</td>
                            </tr>
                            <tr class="dark-gray">
                                <td class="font" colspan="3" ><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td><span class="invisible">asdf</span></td>
                                <td class="end font white font-weight-bold" > 605,462</td>
                                <td class="end font white font-weight-bold" >607,811</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
    </div>
    
</template>

<script>
export default {

}
</script>

<style>

</style>